import { useCallback, useRef, useState } from "react";

const PAGE_SIZE = 100;

export const useInfiniteScroll = <T>(data: T[]) => {
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);
  const [prevDataLength, setPrevDataLength] = useState(data.length);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  if (prevDataLength !== data.length) {
    setPrevDataLength(data.length);
    setVisibleCount(PAGE_SIZE);
  }

  const handleScroll = useCallback(() => {
    const el = scrollContainerRef.current;
    if (!el) return;
    const remainingScroll = el.scrollHeight - el.scrollTop - el.clientHeight;
    if (remainingScroll < el.clientHeight * 2) {
      setVisibleCount((prev) => {
        const next = prev + PAGE_SIZE;
        return next >= data.length ? data.length : next;
      });
    }
  }, [data.length]);

  const visibleData = data.slice(0, visibleCount);

  return { visibleData, scrollContainerRef, handleScroll };
};
